<template>

    <div class="custom-modal"
         @click="closeCustomModal()">

        <div class="custom-modal-window" style="min-height: 750px;" @click.stop>
            <div class="btn-close" @click="closeCustomModal()"></div>
            <div v-if="workplace">

                <h2>{{ workplace.title }}</h2>
                <!-- <h2>Lägg till arbetsplats</h2> -->

                <div class="tabs-container tabs-grey">

                    <div class="tab" :class="{ 'active' : activeTab === 'workplace-modal-info' }"
                         @click="loadView('workplace-modal-info')">Uppgifter</div>
                    <div class="tab" :class="{ 'active' : activeTab === 'workplace-modal-booking' }"
                         @click="loadView('workplace-modal-booking')">Bokningskalender
                    </div>

                </div>

                <div style="padding-top:1.5rem; min-height: 600px;" v-if="fetcher.initialized">

                    <workplace-modal-info
                        :workplace="workplace"
                        :is_deleteable="is_deleteable"
                        @refresh="fetcherFetch()"
                        @close="closeCustomModal()"
                        v-if="activeTab === 'workplace-modal-info'"
                    />
                    <workplace-modal-booking
                        :workplace="workplace"
                        @refresh="fetcherFetch()"
                        v-if="activeTab === 'workplace-modal-booking'"
                    />

                </div>

            </div>

            <div v-else>

                <h2>Laddar...</h2>

                <div class="w-100 d-flex justify-content-center align-items-center" style="min-height: 500px;">

                    <div class="spinner-border text-info" style="color:#999!important;" role="status"></div>

                </div>

            </div>

        </div>
    </div>

</template>

<script>

import workplaceModalInfo from './modal-info.vue'
import workplaceModalBooking from './modal-booking.vue'

import fetcher from '../../../../shared/mixins/fetcher'
import modaler from '../../../../shared/mixins/modaler'

export default {

    mixins: [
        fetcher,
        modaler
    ],

    components: {
        workplaceModalInfo,
        workplaceModalBooking
    },

    props: {
        workplace_id: {
            required: true
        }
    },

    data () {
        return {
            workplace: null,
            is_deleteable: false,
            activeTab: 'workplace-modal-info',
            fetcher: {
                autoFill: [
                    'workplace',
                    'is_deleteable'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/workplaces/' + this.workplace_id
        }
    },

    methods: {

        loadView (name) {
            this.activeTab = name
        }

    }
}
</script>
